module.exports = __webpack_public_path__ + "static/media/8.73de00b7.jpg";